/* src/app/global/components/global-help/global-help-search/global-help-search.component.scss */
:host {
  background: var(--color-accent);
  line-height: 44px;
}
:host .cw-help-search-container {
  height: 100%;
  justify-content: flex-end;
}
:host .cw-help-search-container .cw-global-search-form {
  width: 100%;
}
::placeholder {
  color: var(--color-default-light);
}
:-ms-input-placeholder {
  color: var(--color-default-light);
}
::-ms-input-placeholder {
  color: var(--color-default-light);
}
.cw-global-search-arrow {
  background: var(--color-accent-light);
  position: relative;
}
.cw-global-search-arrow:after {
  border: 22px solid transparent;
  border-left: 15px solid var(--color-accent-light);
  border-right-width: 0;
  content: "";
  left: 100%;
  position: absolute;
  top: 0;
}
.cw-global-search-icon {
  color: var(--color-default-light);
  cursor: pointer;
  font-size: 2rem;
  height: 45px;
  line-height: 1;
  margin-left: 15px;
  padding: 14px;
  text-align: center;
  width: 60px;
}
.cw-global-search-input {
  background-color: transparent;
  border: medium none;
  color: var(--color-default-light);
  font-size: 1.6rem;
  margin-left: 15px;
  margin-right: 15px;
}
.cw-global-search-input:focus {
  border: none;
  outline: 0;
}
.icon-search,
icon-spin {
  color: var(--color-default-light);
}
/*# sourceMappingURL=global-help-search.component.css.map */
